import React from 'react'
import { ReactComponent as WalmeLogo } from './WalmeLogo.svg'
import { ReactComponent as TelegramLogo } from './icons/telegram-logo.svg'
import { ReactComponent as TwitterLogo } from './icons/twitter-logo.svg'
import { ReactComponent as DiscordLogo } from './icons/discord-logo.svg'
import { ReactComponent as GithubLogo } from './icons/github-logo.svg'
import { ReactComponent as LinkedInLogo } from './icons/linkedin-logo.svg'
import { ReactComponent as MediumLogo } from './icons/medium-icon.svg'

import './Footer.scss'

function Footer() {
  const socialLinks = [
    {
      href: 'https://github.com/walme-io',
      label: 'GitHub',
      icon: <GithubLogo />
    },
    {
      href: 'https://discord.gg/2Smw9qcdVU',
      label: 'Discord',
      icon: <DiscordLogo />
    },
    {
      href: 'https://t.me/walmeapp',
      label: 'Telegram',
      icon: <TelegramLogo />
    },
    {
      href: 'https://x.com/walme_io',
      label: 'X (Twitter)',
      icon: <TwitterLogo />
    },
    {
      href: 'https://www.linkedin.com/company/walme-io',
      label: 'LinkedIn',
      icon: <LinkedInLogo />
    },
    {
      href: 'https://blog.walme.io',
      label: 'Medium',
      icon: <MediumLogo />
    }
  ]

  return (
    <footer className="Footer bg-dark py-5">
      <div className="container">
        <div className="row align-items-center mb-4">
          <div className="col-md-3">
            <WalmeLogo style={{ maxWidth: '150px' }} />
            <p className="text-grey small mt-2 mb-0">Crypto Gateway to Your Financial Freedom</p>
          </div>

          <div className="col-md-6 text-center my-3 my-md-0">
            <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit ${link.label}`}
                  className="text-grey social-icon"
                  style={{ width: '20px', height: '20px', display: 'inline-block' }}
                >
                  {link.icon}
                </a>
              ))}
            </div>

            <div className="d-flex justify-content-center align-items-center flex-wrap small">
              <a className="text-grey text-decoration-none mx-2" href="https://walme.io/whitepaper.pdf" target="_blank" rel="noreferrer">
                Whitepaper
              </a>
              <span className="text-grey mx-1">•</span>
              <a className="text-grey text-decoration-none mx-2" href="https://help.walme.io/" target="_blank" rel="noreferrer">
                Help Center
              </a>
              <span className="text-grey mx-1">•</span>
              <a className="text-grey text-decoration-none mx-2" href="https://walme.io/Privacy_Notice.pdf" target="_blank" rel="noreferrer">
                Privacy Policy
              </a>
              <span className="text-grey mx-1">•</span>
              <a className="text-grey text-decoration-none mx-2" href="https://walme.io/Terms_of_Service.pdf" target="_blank" rel="noreferrer">
                Terms of Service
              </a>
            </div>
          </div>

          <div className="col-md-3 text-md-end text-center">
            <p className="text-grey small mb-0">
              © Walme 2025<br />All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
